import {
  List,
  Datagrid,
  ReferenceField,
  TextField,
  BooleanField,
  ChipField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const CongratulationList = () => (
  <List queryOptions={{ meta: { isMy: true } }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <ReferenceField source="friendId" reference="friends" queryOptions={{ meta: { isMy: true } }} />
      <TextField source="eventTitle" />
      <TextField source="text" />
      <BooleanField source="isDraft" />
      <ChipField source="status" />
      <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
    </Datagrid>
  </List>
)

export const CongratulationEdit = () => (
  <Edit queryOptions={{ meta: { isMy: true } }} mutationOptions={{ meta: { isMy: true } }}>
    <SimpleForm>
      <TextInput source="text" />
      <BooleanInput source="isDraft" />
      <SelectInput
        source="status"
        choices={[
          { id: 'pending', name: 'pending' },
          { id: 'rejected', name: 'rejected' },
          { id: 'approved', name: 'approved' },
          { id: 'completed', name: 'completed' },
        ]}
      />
    </SimpleForm>
  </Edit>
)

export const CongratulationShow = () => (
  <Show queryOptions={{ meta: { isMy: true } }}>
    <SimpleShowLayout>
      <ReferenceField source="friendId" reference="friends" queryOptions={{ meta: { isMy: true } }} />
      <TextField source="eventTitle" />
      <TextField source="text" />
      <BooleanField source="isDraft" />
      <ChipField source="status" />
    </SimpleShowLayout>
  </Show>
)
